import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const LoadingDotsStyles = styled.div`
  width: 35px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  ${space}
  ${layout}
`;

export const Dot = styled.div<SpaceProps & LayoutProps>`
  width: 8px;
  height: 8px;
  border-radius: ${tokens.radii.l};
  background-color: ${tokens.colors.primary};
  animation: fade 0.8s ease-in-out alternate infinite;

  &:nth-of-type(1) {
    animation-delay: -0.4s;
  }

  &:nth-of-type(2) {
    animation-delay: -0.2s;
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
